module.exports = __webpack_public_path__ + "static/Portfolio06-d370600bd36560007710f55a8f7bc806.jpg";